<template>
  <div class="main-content" id="main-content">
    <!--    充值-->
    <div v-if="selectedRank=='deposit'" class="relative"
         :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/DiwaliFestivalBg.png')+')'}">
      <!--      上榜奖-->
      <div class="incentiveTip" v-if="(DepositRank.YesterdayRewardStutas && DepositRank.YesterdayRank>0) && rankTipShow"
           @click="rankTipShow = false">
        <div class="incentiveBox" @click.stop>
          <img class="tipCloseIcon" @click="rankTipShow = false"
               src="../../assets/images/DiwaliFestival/close.svg" alt="">
          <div class="incentiveTipTitle">{{ $t('lang.diwaliFestival.incentiveTipTitle') }}</div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription1') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription2') }}
          </div>
          <div class="incentiveNum">₹{{ DepositRank.YesterdayRewardAmount }}</div>
          <div class="incentiveImg">
            <img src="../../assets/images/DiwaliFestival/incentiveImg.svg" alt="">
          </div>
          <div @click="claimDepositReard" class="incentiveBtn">{{ $t('lang.diwaliFestival.incentiveBtn') }}</div>
          <div v-if="language === 'IN'" class="keepTipIN">
            <img src="../../assets/images/DiwaliFestival/keepTipIN.svg" alt="">
          </div>
          <div v-else class="keepTip">
            <img src="../../assets/images/DiwaliFestival/keepTip.svg" alt="">
          </div>
        </div>
      </div>
      <div class="ruleText" @click="ruleTipShow = false" v-if="ruleTipShow">
        <div class="ruleBox" v-if="language === 'IN'" :style="{ 'background-image': `url('${ruleBgIN}')`}" @click.stop>
          <div class="ruleContent" v-html="formatterRuleContent(ruleContentIN)"></div>
        </div>
        <div class="ruleBox" v-else :style="{ 'background-image': `url(${ruleBgEN})` }" @click.stop>
          <div class="ruleContent" v-html="formatterRuleContent(ruleContentEN)"></div>
        </div>
      </div>
      <!--参与奖-->
      <div class="incentiveTip"
           v-if="(DepositRank.YesterdayRewardStutas && DepositRank.YesterdayRewardAmount>0) && DepositRank.YesterdayRank<0 && BetTipShow"
           @click="BetTipShow = false">
        <div class="incentiveBox" @click.stop>
          <img class="tipCloseIcon" @click="BetTipShow = false"
               src="../../assets/images/DiwaliFestival/close.svg"
               alt="">
          <div class="BETincentiveTipTitle">{{ $t('lang.diwaliFestival.BetRedDotTipTitle') }}</div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.Reached') }}₹{{ DepositRank.YesterdayRewardAmount }}
            {{ $t('lang.diwaliFestival.yesterday') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.BETdiscription1') }}
          </div>
          <div class="incentiveNum">₹{{ DepositRank.YesterdayRewardAmount }}</div>
          <div class="incentiveImg">
            <img src="../../assets/images/DiwaliFestival/incentiveImg.svg" alt="">
          </div>
          <div @click="claimDepositReard" class="incentiveBtn">{{ $t('lang.diwaliFestival.incentiveBtn') }}</div>

          <div v-if="language === 'IN'" class="keepTipIN">
            <img src="../../assets/images/DiwaliFestival/keepTipIN.svg" alt="">
          </div>
          <div v-else class="keepTip">
            <img src="../../assets/images/DiwaliFestival/keepTip.svg" alt="">
          </div>
        </div>
      </div>
      <!--  无充值奖励但有下注奖励情况的弹窗    -->
      <div class="incentiveTip" v-if="(BetRank.YesterdayRewardStutas && BetRank.YesterdayRank>0) && rankTipShowBET && !DepositRedDot"
           @click="rankTipShowBET = false">
        <div class="incentiveBox" @click.stop>
          <img class="tipCloseIcon" @click="rankTipShowBET = false"
               src="../../assets/images/DiwaliFestival/close.svg" alt="">
          <div class="incentiveTipTitle">{{ $t('lang.diwaliFestival.incentiveTipTitle') }}</div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discriptionBET') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription2') }}
          </div>
          <div class="incentiveNum">₹{{ BetRank.YesterdayRewardAmount }}</div>
          <div class="incentiveImg">
            <img src="../../assets/images/DiwaliFestival/incentiveImg.svg" alt="">
          </div>
          <div @click="claimBetReard" class="incentiveBtn">{{ $t('lang.diwaliFestival.incentiveBtn') }}</div>
          <div v-if="language === 'IN'" class="keepTipIN">
            <img src="../../assets/images/DiwaliFestival/keepTipIN.svg" alt="">
          </div>
          <div v-else class="keepTip">
            <img src="../../assets/images/DiwaliFestival/keepTip.svg" alt="">
          </div>
        </div>
      </div>
      <!--参与奖-->
      <div class="incentiveTip" v-if="(BetRank.YesterdayRewardStutas && BetRank.YesterdayRewardAmount>0) && BetRank.YesterdayRank<0 && BetTipShowBET && !DepositRedDot"
           @click="BetTipShowBET = false">
        <div class="incentiveBox" @click.stop>
          <img class="tipCloseIcon" @click="BetTipShowBET = false"
               src="../../assets/images/DiwaliFestival/close.svg"
               alt="">
          <div class="BETincentiveTipTitle">{{ $t('lang.diwaliFestival.BetRedDotTipTitle') }}</div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.Reached') }}₹{{ BetRank.YesterdayRewardAmount }}
            {{ $t('lang.diwaliFestival.yesterday') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.BETdiscription1') }}
          </div>
          <div class="incentiveNum">₹{{ BetRank.YesterdayRewardAmount }}</div>
          <div class="incentiveImg">
            <img src="../../assets/images/DiwaliFestival/incentiveImg.svg" alt="">
          </div>
          <div @click="claimBetReard" class="incentiveBtn">{{ $t('lang.diwaliFestival.incentiveBtn') }}</div>
          <div v-if="language === 'IN'" class="keepTipIN">
            <img src="../../assets/images/DiwaliFestival/keepTipIN.svg" alt="">
          </div>
          <div v-else class="keepTip">
            <img src="../../assets/images/DiwaliFestival/keepTip.svg" alt="">
          </div>

        </div>
      </div>
      <div class="topBack">
        <div :class="language==='IN'?'redTipIN':'redTip'" v-if="BetRedDot"></div>
        <img :src="back" alt="" @click="goBack">
        <div class="titleBar">
          <div class="barItem" @click="selectRank('deposit')">
            <div :class="language==='IN'?'itemTitleIN':'itemTitle'"
                 :style="{ color: selectedRank === 'deposit' ? '#FBEED4' : '#4E4E4E' }">
              {{ $t('lang.diwaliFestival.DepositRank') }}
            </div>
            <div class="itemChecked" v-show="selectedRank === 'deposit'"></div>
          </div>
          <div class="barItem2" @click="selectRank('betting')">
            <div :class="language==='IN'?'itemTitleIN':'itemTitle'"
                 :style="{ color: selectedRank === 'betting' ? '#FBEED4' : '#4E4E4E' }">
              {{ $t('lang.diwaliFestival.BettingRank') }}
            </div>
            <div class="itemChecked" v-show="selectedRank === 'betting'"></div>
          </div>
        </div>
      </div>
      <!--      <div class="depositRank">-->
      <div class="yesterdayTopTitle">
        <img class="ruleIcon" src="../../assets/images/DiwaliFestival/ruleIcon.svg" @click="ruleTipShow = !ruleTipShow">
        <!--          <div class="ruleIcon">？</div>-->
        <img class="YesterdayTopIN" v-if="language == 'IN'" src="../../assets/images/DiwaliFestival/YesterdayTopIN.svg"
             alt="">
        <img v-else src="../../assets/images/DiwaliFestival/YesterdayTop.svg" alt="">
      </div>
      <div class="noStart" v-if="ActivityNotStarted">
        <div class="noContent">
          <img src="../../assets/images/DiwaliFestival/nostartIcon.svg" alt="">
          <div class="textBox">
            <div>{{ $t('lang.diwaliFestival.NostartText1') }}</div>
            <div>{{ $t('lang.diwaliFestival.NostartText2') }}</div>
            <div>{{ $t('lang.diwaliFestival.NostartText3') }}</div>
          </div>
        </div>
      </div>
      <div class="lastRank">
        <!-- 排名内容 -->
        <div class="rankON1" v-if="!ActivityNotStarted">
          {{ checkYesterdayRanksContent(DepositRank.YesterdayRanks ? DepositRank.YesterdayRanks[0] : null) }}
        </div>
        <div class="rankON2" v-if="!ActivityNotStarted">
          {{ checkYesterdayRanksContent(DepositRank.YesterdayRanks ? DepositRank.YesterdayRanks[1] : null) }}
        </div>
        <div class="rankON3" v-if="!ActivityNotStarted">
          {{ checkYesterdayRanksContent(DepositRank.YesterdayRanks ? DepositRank.YesterdayRanks[2] : null) }}
        </div>
      </div>
      <!--      排行奖框-->
      <div class="incentive" v-if="(DepositRank.YesterdayRank>0)"
           :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/top10RewardsBg.png')+')'}">
        <div class="incentiveTitle">
          <div class="incentiveTitleText">{{ $t('lang.diwaliFestival.incentiveTitleTextRank') }}</div>
          <div class="incentiveTop">{{ $t('lang.diwaliFestival.Top') }}10 {{ $t('lang.diwaliFestival.Rewards') }}</div>
        </div>
        <div class="incentiveNum">
          <div class="num">₹{{ DepositRank.YesterdayRewardAmount }}</div>
          <div v-if="DepositRank.YesterdayRewardAmount > 0 && !DepositRank.YesterdayRewardStutas" class="claimBtnED">
            {{ $t('lang.diwaliFestival.Claimed') }}
          </div>
          <div @click="rankTipShow = true" v-else class="claimBtn">{{ $t('lang.diwaliFestival.Claim') }}</div>
        </div>
      </div>
      <!--      参与奖弹框-->
      <!--      -->
      <div class="incentive"
           v-if="(DepositRank.YesterdayRewardAmount>0) && DepositRank.YesterdayRank<0"
           :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/top10RewardsBg.png')+')'}">
        <div class="incentiveTitle">
          <div class="incentiveTitleText">{{ $t('lang.diwaliFestival.incentiveTitleText') }}
          </div>
          <!--            <img v-if="language==='IN'" src="../../assets/images/DiwaliFestival/RewardsIN.svg" alt="">-->
          <!--            <img v-else src="../../assets/images/DiwaliFestival/top10RewardsBet.svg" alt="">-->
        </div>
        <div class="incentiveNum">
          <div class="num">₹{{ DepositRank.YesterdayRewardAmount }}</div>
          <div v-if="DepositRank.YesterdayRewardAmount > 0 && !DepositRank.YesterdayRewardStutas" class="claimBtnED">
            {{ $t('lang.diwaliFestival.Claimed') }}
          </div>
          <div @click="BetTipShow = true" v-else class="claimBtn">{{ $t('lang.diwaliFestival.Claim') }}</div>
        </div>
      </div>
      <div class="rank"
           :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/todayRankBg.png')+')'}">
        <div class="rankTitle">{{ $t('lang.diwaliFestival.rankTitle') }}</div>
        <!-- 上一次排名内容 -->
        <div class="tHead">
          <div class="tHeadItem">{{ $t('lang.diwaliFestival.Rank') }}</div>
          <div class="tHeadItem">{{ $t('lang.diwaliFestival.Nickname') }}</div>
          <div class="tHeadItem">
            <div>{{ $t('lang.diwaliFestival.Amount') }}</div>
            <div class="discriptTion">{{ $t('lang.diwaliFestival.distance') }}</div>
          </div>
        </div>
        <div class="overEnterprise" v-if="ActivityEnd">
          <div>{{ $t('lang.diwaliFestival.overEnterprise1') }}</div>
          <div>{{ $t('lang.diwaliFestival.overEnterprise2') }}</div>
        </div>
        <div class="tBody" v-if="!ActivityEnd">

          <div class="tBodyRow" v-for="(item,index) in DepositRank.TodayRanks" :key="index">
            <div class="tBodyRowItem">{{ item.Rank }}</div>
            <div class="tBodyRowItem">{{ item.Name }}</div>
            <div class="tBodyRowItem" v-if="index !==0">{{ item.DifferenceValue }}</div>
            <div class="tBodyRowItem" v-else>*****</div>
          </div>
        </div>
      </div>
      <!--      </div>-->
      <div class="myTodayRank">
        <div class="userInfo" v-if="userInfo">
          <div class="user">
            <img src="../../assets/images/DiwaliFestival/userImg.svg" alt="">
            <div class="userName">{{ userInfo.UserName }}</div>
          </div>
          <div v-if="!ActivityEnd">
            <div v-if="DepositRank.TodayRank > 0" class="top">{{ $t('lang.diwaliFestival.Top') }}{{ DepositRank.TodayRank }}-</div>
            <div v-else class="userRank">{{ $t('lang.diwaliFestival.NotList') }}</div>
          </div>

        </div>
        <div class="progressBarBox">
          <div class="overEnterpriseBottomBox" v-if="ActivityEnd && userInfo">
            <div>{{ $t('lang.diwaliFestival.overEnterprise1Bottom') }}</div>
            <div>{{ $t('lang.diwaliFestival.overEnterprise2Bottom') }}</div>
          </div>
          <div v-if="!userInfo" @click="goLogin" class="noLoginBtn">{{ $t('lang.diwaliFestival.noLoginBtn') }}</div>
          <div class="TimesTip" v-if=" userInfo && DepositRank.TodayRank < 0 && !ActivityEnd">
            <div>{{ $t('lang.diwaliFestival.Today') }}</div>
            <div>{{ $t('lang.diwaliFestival.Deposit') }}</div>
          </div>
          <div class="progressBox" v-if="userInfo && !ActivityEnd">
            <DiwaliFestivalProgressBar v-if="DepositRank.TodayRank < 0" :data="DepositRank"></DiwaliFestivalProgressBar>
          </div>
          <div class="nothingBox" v-if="DepositRank.TodayRank > 0 && !ActivityEnd">
            <div class="nothingText">{{ $t('lang.diwaliFestival.NothingText') }}</div>
            <div class="detailLink" @click="openRule()">{{ $t('lang.diwaliFestival.DetailLink') }}</div>
          </div>

        </div>
      </div>
    </div>
    <!--    下注-->
    <div v-else class="relative"
         :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/DiwaliFestivalBg.png')+')'}">
      <!--      上榜奖-->
      <div class="incentiveTip" v-if="(BetRank.YesterdayRewardStutas && BetRank.YesterdayRank>0) && rankTipShowBET"
           @click="rankTipShowBET = false">
        <div class="incentiveBox" @click.stop>
          <img class="tipCloseIcon" @click="rankTipShowBET = false"
               src="../../assets/images/DiwaliFestival/close.svg" alt="">
          <div class="incentiveTipTitle">{{ $t('lang.diwaliFestival.incentiveTipTitle') }}</div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription1') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.discription2') }}
          </div>
          <div class="incentiveNum">₹{{ BetRank.YesterdayRewardAmount }}</div>
          <div class="incentiveImg">
            <img src="../../assets/images/DiwaliFestival/incentiveImg.svg" alt="">
          </div>
          <div @click="claimBetReard" class="incentiveBtn">{{ $t('lang.diwaliFestival.incentiveBtn') }}</div>
          <div v-if="language === 'IN'" class="keepTipIN">
            <img src="../../assets/images/DiwaliFestival/keepTipIN.svg" alt="">
          </div>
          <div v-else class="keepTip">
            <img src="../../assets/images/DiwaliFestival/keepTip.svg" alt="">
          </div>
        </div>
      </div>
      <!--参与奖-->
      <div class="incentiveTip"
           v-if="(BetRank.YesterdayRewardStutas && BetRank.YesterdayRewardAmount>0) && BetRank.YesterdayRank<0 && BetTipShowBET"
           @click="BetTipShowBET = false">
        <div class="incentiveBox" @click.stop>
          <img class="tipCloseIcon" @click="BetTipShowBET = false"
               src="../../assets/images/DiwaliFestival/close.svg"
               alt="">
          <div class="BETincentiveTipTitle">{{ $t('lang.diwaliFestival.BetRedDotTipTitle') }}</div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.Reached') }}₹{{ BetRank.YesterdayRewardAmount }}
            {{ $t('lang.diwaliFestival.yesterday') }}
          </div>
          <div class="discription">
            {{ $t('lang.diwaliFestival.BETdiscription1') }}
          </div>
          <div class="incentiveNum">₹{{ BetRank.YesterdayRewardAmount }}</div>
          <div class="incentiveImg">
            <img src="../../assets/images/DiwaliFestival/incentiveImg.svg" alt="">
          </div>
          <div @click="claimBetReard" class="incentiveBtn">{{ $t('lang.diwaliFestival.incentiveBtn') }}</div>
          <div v-if="language === 'IN'" class="keepTipIN">
            <img src="../../assets/images/DiwaliFestival/keepTipIN.svg" alt="">
          </div>
          <div v-else class="keepTip">
            <img src="../../assets/images/DiwaliFestival/keepTip.svg" alt="">
          </div>

        </div>
      </div>
      <div class="ruleText" @click="ruleTipShow = false" v-if="ruleTipShow">
        <div class="ruleBox" v-if="language === 'IN'" :style="{ 'background-image': `url('${ruleBgIN}')`}" @click.stop>
          <div class="ruleContent" v-html="formatterRuleContent(ruleContentIN)"></div>
        </div>
        <div class="ruleBox" v-else :style="{ 'background-image': `url(${ruleBgEN})` }" @click.stop>
          <div class="ruleContent" v-html="formatterRuleContent(ruleContentEN)"></div>
        </div>
      </div>
      <!--      -->
      <div class="topBack">
        <div :class="language==='IN'?'DepositRedTipIN':'DepositRedTip'" v-if="DepositRedDot"></div>
        <img :src="back" alt="" @click="goBack">
        <div class="titleBar">
          <div class="barItem" @click="selectRank('deposit')">
            <div :class="language==='IN'?'itemTitleIN':'itemTitle'"
                 :style="{ color: selectedRank === 'deposit' ? '#FBEED4' : '#4E4E4E' }">
              {{ $t('lang.diwaliFestival.DepositRank') }}
            </div>
            <div class="itemChecked" v-show="selectedRank === 'deposit'"></div>
          </div>
          <div class="barItem2" @click="selectRank('betting')">
            <div :class="language==='IN'?'itemTitleIN':'itemTitle'"
                 :style="{ color: selectedRank === 'betting' ? '#FBEED4' : '#4E4E4E' }">
              {{ $t('lang.diwaliFestival.BettingRank') }}
            </div>
            <div class="itemChecked" v-show="selectedRank === 'betting'"></div>
          </div>
        </div>
      </div>
      <!--      <div class="depositRank">-->
      <div class="yesterdayTopTitle">
        <img class="ruleIcon" src="../../assets/images/DiwaliFestival/ruleIcon.svg" @click="ruleTipShow = !ruleTipShow">
        <!--          <div class="ruleIcon">？</div>-->
        <img class="YesterdayTopIN" v-if="language == 'IN'" src="../../assets/images/DiwaliFestival/YesterdayTopIN.svg"
             alt="">
        <img v-else src="../../assets/images/DiwaliFestival/YesterdayTop.svg" alt="">
      </div>
      <div class="noStart" v-if="ActivityNotStarted">
        <div class="noContent">
          <img src="../../assets/images/DiwaliFestival/nostartIcon.svg" alt="">
          <div class="textBox">
            <div>{{ $t('lang.diwaliFestival.NostartText1') }}</div>
            <div>{{ $t('lang.diwaliFestival.NostartText2') }}</div>
            <div>{{ $t('lang.diwaliFestival.NostartText3') }}</div>
          </div>
        </div>
      </div>
      <div class="lastRank">
        <!-- 排名内容 -->
        <div class="rankON1" v-if="!ActivityNotStarted">
          {{ checkYesterdayRanksContent(BetRank.YesterdayRanks ? BetRank.YesterdayRanks[0] : null) }}
        </div>
        <div class="rankON2" v-if="!ActivityNotStarted">
          {{ checkYesterdayRanksContent(BetRank.YesterdayRanks ? BetRank.YesterdayRanks[1] : null) }}
        </div>
        <div class="rankON3" v-if="!ActivityNotStarted">
          {{ checkYesterdayRanksContent(BetRank.YesterdayRanks ? BetRank.YesterdayRanks[2] : null) }}
        </div>
      </div>
      <!--      betting排行奖框-->
      <div class="incentive" v-if="BetRank.YesterdayRank>0"
           :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/top10RewardsBg.png')+')'}">
        <div class="incentiveTitle">
          <div class="incentiveTitleText">{{ $t('lang.diwaliFestival.incentiveTitleTextRank') }}</div>
          <div class="incentiveTop">{{ $t('lang.diwaliFestival.Top') }}10 {{ $t('lang.diwaliFestival.Rewards') }}</div>
        </div>
        <div class="incentiveNum">
          <div class="num">₹{{ BetRank.YesterdayRewardAmount }}</div>
          <div v-if="BetRank.YesterdayRewardAmount > 0 && !BetRank.YesterdayRewardStutas" class="claimBtnED">
            {{ $t('lang.diwaliFestival.Claimed') }}
          </div>
          <div @click="rankTipShowBET = true" v-else class="claimBtn">{{ $t('lang.diwaliFestival.Claim') }}</div>
        </div>
      </div>
      <!--      betting参与奖框-->
      <!--      -->
      <div class="incentive"
           v-if="(BetRank.YesterdayRewardAmount>0) && BetRank.YesterdayRank<0"
           :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/top10RewardsBg.png')+')'}">
        <div class="incentiveTitle">
          <div class="incentiveTitleText">{{ $t('lang.diwaliFestival.BettingincentiveTitleText') }}
          </div>
        </div>
        <div class="incentiveNum">
          <div class="num">₹{{ BetRank.YesterdayRewardAmount }}</div>
          <div v-if="BetRank.YesterdayRewardAmount > 0 && !BetRank.YesterdayRewardStutas" class="claimBtnED">
            {{ $t('lang.diwaliFestival.Claimed') }}
          </div>
          <div @click="BetTipShowBET = true" v-else class="claimBtn">{{ $t('lang.diwaliFestival.Claim') }}</div>
        </div>
      </div>
      <div class="rank"
           :style="{backgroundImage:'url('+require('../../assets/images/DiwaliFestival/todayRankBg.png')+')'}">
        <div class="rankTitle">{{ $t('lang.diwaliFestival.rankTitle') }}</div>
        <!-- 上一次排名内容 -->
        <div class="tHead">
          <div class="tHeadItem">{{ $t('lang.diwaliFestival.Rank') }}</div>
          <div class="tHeadItem">{{ $t('lang.diwaliFestival.Nickname') }}</div>
          <div class="tHeadItem">
            <div>{{ $t('lang.diwaliFestival.Amount') }}</div>
            <div class="discriptTion">{{ $t('lang.diwaliFestival.distance') }}</div>
          </div>
        </div>
        <div class="overEnterprise" v-if="ActivityEnd">
          <div>{{ $t('lang.diwaliFestival.overEnterprise1') }}</div>
          <div>{{ $t('lang.diwaliFestival.overEnterprise2') }}</div>
        </div>
        <div class="tBody" v-if="!ActivityEnd">
          <div class="tBodyRow" v-for="(item,index) in BetRank.TodayRanks" :key="index">
            <div class="tBodyRowItem">{{ item.Rank }}</div>
            <div class="tBodyRowItem">{{ item.Name }}</div>
            <div class="tBodyRowItem" v-if="index !==0">{{ item.DifferenceValue }}</div>
            <div class="tBodyRowItem" v-else>*****</div>
          </div>
        </div>
      </div>
      <div class="myTodayRank">
        <div class="userInfo" v-if="userInfo">
          <div class="user">
            <img src="../../assets/images/DiwaliFestival/userImg.svg" alt="">
            <div class="userName">{{ userInfo.UserName }}</div>
          </div>
          <div v-if="!ActivityEnd">
            <div v-if="BetRank.TodayRank > 0" class="top">{{ $t('lang.diwaliFestival.Top') }}{{ BetRank.TodayRank }}-</div>
            <div v-else class="userRank">{{ $t('lang.diwaliFestival.NotList') }}</div>
          </div>

        </div>
        <div class="progressBarBox">
          <div class="overEnterpriseBottomBox" v-if="ActivityEnd && userInfo">
            <div>{{ $t('lang.diwaliFestival.overEnterprise1Bottom') }}</div>
            <div>{{ $t('lang.diwaliFestival.overEnterprise2Bottom') }}</div>
          </div>
          <div v-if="!userInfo" @click="goLogin" class="noLoginBtn">{{ $t('lang.diwaliFestival.noLoginBtn') }}</div>
          <div class="TimesTip" v-if="BetRank.TodayRank < 0 && userInfo  && !ActivityEnd">
            <div>{{ $t('lang.diwaliFestival.Today') }}</div>
            <div>{{ $t('lang.diwaliFestival.Betting') }}</div>
          </div>
          <div class="progressBox" v-if="userInfo && !ActivityEnd">
            <DiwaliFestivalProgressBar v-if="BetRank.TodayRank < 0" :data="BetRank"></DiwaliFestivalProgressBar>
          </div>
          <div class="nothingBox" v-if="BetRank.TodayRank > 0 && !ActivityEnd">
            <div class="nothingText">{{ $t('lang.diwaliFestival.NothingText') }}</div>
            <div class="detailLink" @click="openRule()">{{ $t('lang.diwaliFestival.DetailLink') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import request from '@/service'
import back from '@/assets/images/DiwaliFestival/back.svg'
import DiwaliFestivalProgressBar from '../../components/DiwaliFestivalProgressBar/index.vue'
import {fetchBalance} from '@/utils'

export default {
  name: 'index',
  components: {
    TopBack,
    DiwaliFestivalProgressBar
  },
  data () {
    return {
      back,
      fetchBalance,
      BetRedDot: false,
      DepositRedDot: false,
      ActivityNotStarted: false,
      ActivityEnd: false,
      ruleBgEN: '',
      ruleBgIN: '',
      ruleContentEN: '',
      ruleContentIN: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      language: localStorage.getItem('locale'),
      rankTipShow: false,
      BetTipShow: false,
      ruleTipShow: false,
      incentiveShow: true,
      selectedRank: 'deposit', // 默认选中存款排名
      DepositRank: {
        // YesterdayRewardAmount: null,
        // YesterdayRewardStutas: null
      },
      BetRank: {},
      rankTipShowBET: false,
      BetTipShowBET: false,
      rows: [
        // 初始化一些示例数据
        {rank: 1, nickname: 'yonghudemingzi', amount: '1000'},
        {rank: 2, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 3, nickname: 'yonghudemingzi', amount: '1000'},
        {rank: 4, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 5, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 6, nickname: 'yonghudemingzi', amount: '1000'},
        {rank: 7, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 8, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 9, nickname: 'yonghudemingzi', amount: '1000'},
        {rank: 10, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 11, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 12, nickname: 'yonghudemingzi', amount: '100'},
        {rank: 13, nickname: 'yonghudemingzi', amount: '10000'},
        {rank: 14, nickname: 'yonghudemingzi', amount: '10000'},
        {rank: 15, nickname: 'yonghudemingzi1111', amount: '10000'}
        // ...更多行数据
      ]
    }
  },
  watch: {
    '$store.state.locale': function (val) {
      this.language = val
    }
  },
  mounted () {
    this.getDiwaliestvalData()
  },
  computed: {
    getIncentiveShow () {
      if (this.DepositRank === {} || this.BetRank === {}) return false
      if (this.selectedRank === 'deposit' && this.DepositRank.YesterdayRewardAmount !== 0) {
        return true
      } else if (this.selectedRank === 'betting' && this.BetRank.YesterdayRewardAmount !== 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    formatterRuleContent (content) {
      return content.replace(/\\n|\r?\n/g, '</p><p>')
    },
    goLogin () {
      this.$router.push('/Login')
    },
    openRule () {
      this.ruleTipShow = !this.ruleTipShow
    },
    checkYesterdayRanksContent (val) {
      if (val) {
        return val.Name
      } else {
        return null
      }
    },
    claimDepositReard () {
      request('post', 'innovation/diwali/deposit/collect', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null}).then(res => {
        if (res) {
          this.fetchBalance()
          this.getDiwaliestvalData()
          this.selectedRank = ''
          this.selectedRank = 'deposit'
        }
      })
    },
    claimBetReard () {
      request('post', 'innovation/diwali/bet/collect', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null}).then(res => {
        if (res) {
          this.fetchBalance()
          this.getDiwaliestvalData()
          this.selectedRank = ''
          this.selectedRank = 'betting'
        }
      })
    },
    getDiwaliestvalData () {
      request('post', '/innovation/diwali/get/data', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null}).then(res => {
        if (res) {
          this.ActivityNotStarted = res.ActivityNotStarted
          this.DepositRank = res.DepositRank
          this.BetRank = res.BetRank
          this.rankTipShow = (res.DepositRank.YesterdayRewardStutas && res.DepositRank.YesterdayRank > 0)
          this.BetTipShow = (res.DepositRank.YesterdayRewardStutas && res.DepositRank.YesterdayRewardAmount > 0) && res.DepositRank.YesterdayRank < 0
          this.rankTipShowBET = (res.BetRank.YesterdayRewardStutas && res.BetRank.YesterdayRank > 0)
          this.BetTipShowBET = (res.BetRank.YesterdayRewardStutas && res.BetRank.YesterdayRewardAmount > 0) && res.BetRank.YesterdayRank < 0
          this.ruleBgEN = res.RuleBackgroundEN
          this.ruleBgIN = res.RuleBackgroundIN
          this.ruleContentEN = res.RuleEN
          this.ruleContentIN = res.RuleIN
          this.BetRedDot = res.BetRedDot
          this.DepositRedDot = res.DepositRedDot
          this.ActivityEnd = res.ActivityEnd
        }
      })
    },
    goBack () {
      if (this.handelBack) {
        this.handelBack()
      } else {
        this.$router.go(-1)
      }
    },
    selectRank (rank) {
      this.selectedRank = rank
    }
  }
}
</script>

<style scoped lang="less">
.main-content {
  position: fixed;
  padding: 56px 0 0 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  //overflow-y: auto;
  .relative {
    position: relative;
    width: 100vw;
    height: 224vw;
    //background-image: url("../../assets/images/DiwaliFestival/DiwaliFestivalBg.png");
    background-size: 100% 106%;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
    background-position-y: -12vw;

    .incentiveTip {
      position: fixed;
      background: rgba(0, 0, 0, .6);
      height: 100vh;
      width: 100%;
      z-index: 99;
      padding: 10vw;

      .incentiveBox {
        background: rgb(30, 30, 30);
        height: 103.61vw;
        width: 100%;
        border-radius: 3vw;
        position: relative;
        top: 27vw;
        z-index: 99;
        padding: 5vw;

        .BETincentiveTipTitle {
          height: 12.22vw;
          //border: 1px solid red;
          font-size: 6vw;
          font-weight: 700;
          color: #fff;
          text-align: center;
          line-height: 7.22vw;
        }

        .incentiveTipTitle {
          height: 7.22vw;
          //border: 1px solid red;
          font-size: 6vw;
          font-weight: 700;
          color: #fff;
          text-align: center;
          line-height: 7.22vw;
        }

        .discription {
          font-size: 4.2vw;
          font-weight: 500;
          color: #C3C3C3;
          text-align: center;
          line-height: 7.22vw;
          //border: 1px solid red;
        }

        .incentiveNum {
          /* 设置字体大小和其他样式 */
          font-family: Inter;
          font-size: 10vw;
          font-weight: bold;
          /* 创建渐变背景 */
          background-image: linear-gradient(to left,
          #F0D55E 0%,
          #F0D55E 46%,
          #E1A959 68%,
          #E2D173 100%);
          /* 将背景裁剪到文字上 */
          -webkit-background-clip: text;
          background-clip: text;
          /* 使文字颜色透明，以便背景色能够显示 */
          color: transparent;
          /* 为背景添加私有前缀以支持旧版浏览器 */
          -webkit-text-fill-color: transparent;
          text-align: center;
        }

        .incentiveImg {
          //position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 62.894vw;
            height: 41.975vw;
          }
        }

        .incentiveBtn {
          width: 59.98vw;
          height: 8.18vw;
          position: absolute;
          top: 88vw;
          left: 10vw;
          color: #000;
          text-align: center;
          line-height: 8.18vw;
          font-weight: 700;
          background: linear-gradient(90deg, #FFEE7C 0%, #FFE293 100%);
          border-radius: 0.8333vw;
        }

        .keepTip {
          position: absolute;
          top: 98vw;
          //border:1px solid red;
          width: 70vw;
          //left: 9vw;
          display: flex;
          justify-content: center;
        }

        .keepTipIN {
          position: absolute;
          top: 98vw;
          //border:1px solid red;
          width: 70vw;
          //left: 9vw;
          display: flex;
          justify-content: center;
        }

        .tipCloseIcon {
          position: absolute;
          top: 107.5vw;
          left: 38vw;
        }
      }
    }

    .ruleText {
      position: fixed;
      background: rgba(0, 0, 0, .6);
      height: 100vh;
      width: 100%;
      z-index: 99;
      padding: 10vw;

      .ruleBox {
        //background: rgb(30, 30, 30);
        height: 145.27vw;
        width: 100%;
        border-radius: 3vw;
        //pointer-events: none;
        //border: 1px solid red;
        background-size: 100% 100%;

        .ruleBoxBottomImg {
          position: absolute;
          width: 76%;
          top: 31vw;
        }

        .ruleTitle {
          position: relative;
          left: 11vw;
          top: 5vw;
        }

        .ruleContent {
          height: 116vw;
          width: 88%;
          //background: #fff;
          border-radius: 2vw;
          position: relative;
          top: 20vw;
          margin: 5vw;
          padding: 3vw;
          font-size: 3.6vw;
          font-weight: 700;
          color: #000;
          //border: 1px solid red;
          line-height: 4.7vw;
          overflow-y: auto;
        }
      }
    }

    .topBack {
      position: relative;
      top: 1vw;
      display: flex;
      align-items: center;
      height: 8vw;

      .redTipIN {
        height: 2vw;
        width: 2vw;
        background: red;
        border-radius: 50vw;
        position: absolute;
        left: 82vw;
        top: 1vw;
        z-index: 7;
        background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%)
      }

      .redTip {
        height: 2vw;
        width: 2vw;
        background: red;
        border-radius: 50vw;
        position: absolute;
        left: 79.5vw;
        top: 1vw;
        z-index: 7;
        background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%)
      }

      .DepositRedTipIN {
        height: 2vw;
        width: 2vw;
        background: red;
        border-radius: 50vw;
        position: absolute;
        left: 45vw;
        top: 1vw;
        z-index: 7;
        background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%)
      }

      .DepositRedTip {
        height: 2vw;
        width: 2vw;
        background: red;
        border-radius: 50vw;
        position: absolute;
        left: 48vw;
        top: 1vw;
        z-index: 7;
        background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%)
      }

      img {
        width: 4.6vw;
        margin-left: 5vw;
        z-index: 99;
      }

      .titleBar {
        height: 100%;
        width: 61vw;
        display: flex;
        align-items: center;
        margin-left: 11vw;
        position: relative;
        z-index: 99;

        .barItem, .barItem2 {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 30vw;
          position: relative;
          text-transform: capitalize;

          .itemTitleIN {
            font-weight: 700;
            font-size: 3.3vw;
            color: #4E4E4E; // 默认文字颜色
          }

          .itemTitle {
            font-weight: 700;
            font-size: 3.88vw;
            color: #4E4E4E; // 默认文字颜色
          }

          .itemChecked {
            height: 0.6vw;
            position: absolute;
            top: 6.2vw;
            background: #FBEED4;
            width: 11vw;
            border-radius: 2vw;
          }
        }

        .barItem2 {
          margin-left: 5vw;
        }
      }

    }

    .yesterdayTopTitle {
      height: 5.8vw;
      width: 100%;
      //border: 1px solid red;
      position: relative;
      top: 2vw;

      .YesterdayTopIN {
        position: relative;
        left: 36vw;
        top: 1vw;
      }

      .ruleIcon {
        //height: 5.5vw;
        //width: 5.5vw;
        //border-radius: 5vw;
        //border: 0.5vw solid #564F4F;
        //color: rba(100, 100, 88);
        //font-size: 3.5vw;
        position: relative;
        left: 88vw;
        top: -7.5vw;
        //text-align: center;
        //line-height: 6vw;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 1.5vw;
        z-index: 99;
      }

      img {
        height: 5.8vw;
        position: absolute;
        left: 30vw;
        top: 6vw;
      }
    }

    .noStart {
      position: absolute;
      height: 97vw;
      width: 100%;
      //background: red;
      z-index: 10;
      top: 0;
      background: linear-gradient(to bottom, rgba(0, 0, 0, .6) 0%, rgba(0, 0, 0, .6) 80%, rgba(0, 0, 0, 0) 100%); /* 从左到右的渐变 */
      //background: rgba(0,0,0,.6);
      .noContent {
        height: 100%;
        //border: 1px solid red;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {

        }

        .textBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          position: relative;
          top: 4vw;

          .text {
            //border: 1px solid red;
            width: 82vw;

          }
        }

      }
    }

    .lastRank {
      height: 60vw;
      width: 100%;
      //border: 1px solid red;
      position: relative;
      top: 13vw;
      color: #fff;
      font-size: 3vw;
      font-weight: 600;
      letter-spacing: 0.1vw;

      .rankON1 {
        position: relative;
        top: 3vw;
        left: 50%;
        transform: translate(-50%);
        width: 29.722vw;
        overflow: hidden;
        white-space: nowrap;
        text-align: center;
        text-overflow: ellipsis;
      }

      .rankON2 {
        position: relative;
        left: 5.5vw;
        top: 8.9vw;
        width: 29.722vw;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        white-space: nowrap;
      }

      .rankON3 {
        position: relative;
        left: 63.2vw;
        top: 8.55vw;
        width: 29.722vw;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        white-space: nowrap;
      }
    }

    .incentive {
      margin-left: 3.2vw;
      width: 94vw;
      height: 24vw;
      //border: 1px solid red;
      //background: url("../../assets/images/DiwaliFestival/top10RewardsBg.png");
      background-size: 100%;
      position: relative;
      top: 16vw;
      border-radius: 2vw;
      padding: 5vw;
      margin-bottom: 2vw;

      .incentiveTitle {
        //border: 1px solid red;
        height: 3.7vw;
        width: 50vw;
        border-radius: 10vw;
        background: linear-gradient(to right, #FF0000 0%, #290808 80%, rgba(0, 0, 0, 0) 100%);
        display: flex;

        .incentiveTitleText {
          position: relative;
          font-size: 3.5vw;
          color: #fff;
          font-weight: 700;
          left: 1vw;
          top: -1.4vw;
          white-space: nowrap;
        }

        .incentiveTop {
          position: relative;
          font-size: 3.5vw;
          left: 3vw;
          top: -1.4vw;
          color: #E4D9BE;
          font-size: 3.2vw;
          white-space: nowrap;
        }

        img {
        }
      }

      .incentiveNum {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 1vw;

        .num {
          background-image: linear-gradient(to right, #FFFF92, #FFD972);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-size: 7vw;
          font-weight: 700;
        }

        .claimBtn {
          width: 32.5vw;
          height: 7.5vw;
          border-radius: 1vw;
          background: linear-gradient(90deg, #FFEE7C 0%, #FFE293 100%);
          color: #000;
          text-align: center;
          line-height: 7.5vw;
          font-weight: 700;
          font-size: 4.7vw;

        }

        .claimBtnED {
          width: 32.5vw;
          height: 7.5vw;
          border-radius: 1vw;
          background: #A0A0A0;
          color: #000;
          text-align: center;
          line-height: 7.5vw;
          font-weight: 700;
          font-size: 4.7vw;
          text-transform: capitalize;
        }
      }
    }

    .rank {
      height: 59vw;
      margin-left: 3.2vw;
      width: 94vw;
      //background: rgba(0,0,0,.6);
      //border-radius: 2vw;
      //border:1px solid red;
      //background: url("../../assets/images/DiwaliFestival/todayRankBg.png") no-repeat;
      background-size: 100%;
      position: relative;
      top: 16vw;
      border-radius: 2vw;
      overflow: hidden;
      padding-right: 2vw;
      /* 自定义滚动条的整体样式 */

      ::-webkit-scrollbar {
        width: 2vw; /* 设置滚动条的宽度 */
        padding-right: 2vw;
      }

      /* 滚动槽 */

      ::-webkit-scrollbar-track {
        background: #000; /* 设置滚动槽的背景颜色 */
        border-radius: 5vw; /* 设置滚动槽的圆角 */
      }

      /* 滚动条滑块 */

      ::-webkit-scrollbar-thumb {
        background: #fff; /* 设置滑块的背景颜色 */
        border-radius: 6px; /* 设置滑块的圆角 */
      }

      /* 当鼠标悬停在滚动条上时滑块的状态 */

      ::-webkit-scrollbar-thumb:hover {
        background: #555; /* 设置鼠标悬停时滑块的颜色 */
      }

      .rankTitle {
        height: 12vw;
        //border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 5vw;
        color: transparent; /* 将文字颜色设置为透明，以便背景渐变显示 */
        background-image: linear-gradient(to top, #FFE281, #FFF1B5 50%, #CEBF5E); /* 设置渐变背景 */
        -webkit-background-clip: text; /* 背景裁剪仅应用于文字 */
        background-clip: text;
        //display: inline-block; /* 确保可以应用背景渐变 */
      }

      .tHead {
        display: flex;
        justify-content: space-around;

        .tHeadItem {
          flex: 1;
          text-align: center;
          color: #B9B0B0;
          font-size: 4vw;

          .discriptTion {
            font-size: 3vw;
          }
        }
      }

      .overEnterprise {
        height: 37vw;
        //border: 1px solid red;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        color: #B5B5B5;
        font-size: 4.2vw;
        line-height: 5.5vw;
        padding-bottom: 5vw;
      }

      .tBody {
        //border: 1px solid red;
        height: 37vw;
        font-weight: 700;
        overflow-y: scroll;
        //padding-bottom: 5vw;
        .tBodyRow {
          display: flex;
          justify-content: space-around;
          height: 8vw;

          .tBodyRowItem {
            flex: 1;
            //border: 1px solid red;
            text-align: center;
            line-height: 8vw;
            color: #fff;
            font-size: 3.7vw;
            white-space: nowrap; /* 防止文本换行 */
            overflow: hidden; /* 隐藏超出容器的文本 */
            text-overflow: ellipsis; /* 显示省略号 */
          }
        }
      }
    }

    .myTodayRank {
      position: relative;
      top: 18.4vw;
      height: 36vw;
      margin-left: 3.2vw;
      width: 94vw;
      //border: 1px solid red;
      background: rgba(0, 0, 0, .4);
      border-radius: 2vw;
      padding: 2vw;

      .userInfo {
        position: absolute;
        //border: 1px solid red;
        width: 87vw;
        height: 8vw;
        border-radius: 1vw;
        top: 1vw;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 4vw;
        font-weight: 700;

        .user {
          display: flex;
          align-items: center;
          color: #fff;

          img {
          }

          .userName {
            white-space: nowrap; /* 防止文本换行 */
            overflow: hidden; /* 隐藏超出容器的文本 */
            text-overflow: ellipsis; /* 显示省略号 */
            margin-left: 2vw;
            width: 33vw;
            //border: 1px solid red;
          }
        }

        .userRank {
          color: #929292;
        }

        .top {
          color: #fff;
        }
      }

      .progressBarBox {
        //border: 1px solid red;
        height: 24vw;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 2vw;
        position: relative;
        top: 8vw;
        display: flex;
        align-items: center;

        .overEnterpriseBottomBox {
          width: 100%;
          //border: 1px solid red;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          color: #999999;
          font-size: 4.2vw;
        }

        .noLoginBtn {
          padding: 1.2vw 8vw 1.2vw 8vw;
          font-size: 4.5vw;
          color: #000;
          background-image: linear-gradient(to right, #FFEE7C 0%, #FFE293 100%);
          border-radius: 1vw;
          font-weight: 700;
          position: relative;
          left: 18.5vw;
          text-transform: capitalize;
        }

        .TimesTip {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-weight: 700;
          font-size: 4vw;
          color: #D3D3D3;
          position: absolute;
          left: 2vw;
        }

        .progressBox {
          height: 15vw;
          //border: 1px solid red;
          width: 62vw;
          position: absolute;
          left: 20vw;
          display: flex;
          align-items: center;
        }

        .nothingBox {
          font-size: 3.4vw;
          color: #fff;
          display: flex;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 1;

          .nothingText {
            font-weight: 700;
          }

          .detailLink {
            padding-top: 5vw;
            color: #469CFF;
            border-bottom: 1px solid;
            font-size: 3vw;
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DiwaliFestival/index.vue